export default "__VITE_ASSET__DSzUq0YV__"